/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Characters_LabelInputs */

const en_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who are the main characters in the content?`)
};

const fr_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui sont les personnages principaux de l'histoire ?`)
};

const de_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer sind die Hauptfiguren in der Geschichte?`)
};

const it_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi sono i personaggi principali del contenuto?`)
};

const ru_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кто являются главными героями данного произведения?`)
};

const es_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quiénes son los personajes principales de la historia?`)
};

const zh_cn2_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这部作品的主要人物有哪些？`)
};

const ja_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このコンテンツの主要登場人物は誰ですか？`)
};

const hi_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस कहानी के मुख्य पात्र कौन हैं?`)
};

const pt_pt2_main_characters_label = /** @type {(inputs: Main_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem são os personagens principais da história?`)
};

/**
* | output |
* | --- |
* | "Who are the main characters in the content?" |
*
* @param {Main_Characters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_characters_label = /** @type {((inputs?: Main_Characters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Characters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_main_characters_label(inputs)
	if (locale === "de") return de_main_characters_label(inputs)
	if (locale === "it") return it_main_characters_label(inputs)
	if (locale === "ru") return ru_main_characters_label(inputs)
	if (locale === "es") return es_main_characters_label(inputs)
	if (locale === "zh-CN") return zh_cn2_main_characters_label(inputs)
	if (locale === "ja") return ja_main_characters_label(inputs)
	if (locale === "hi") return hi_main_characters_label(inputs)
	if (locale === "pt-PT") return pt_pt2_main_characters_label(inputs)
	return en_main_characters_label(inputs)
});